<template>
  <v-container>
    <v-card
      class="pa-2"
    >
      <v-img
        class="white--text align-end"
        height="250"
        position="center top"
        gradient="to bottom, rgba(255,255,255,0), rgba(0,0,0,0.5)"
        src="../assets/title.jpg"
      >
        <v-card-title>소면공방 파트너 센터 회원가입</v-card-title>
      </v-img>
      <v-form
        ref="form"
        lazy-validation
      >
        <v-text-field
          v-model="form.email"
          label="E-mail"
          required
        ></v-text-field>

        <v-text-field
          v-model="form.password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          label="비밀 번호"
          hint="At least 8 characters"
          counter
          @click:append="show1 = !show1"
        ></v-text-field>

        <v-alert
          type="error"
          dense
          outlined
        >
          로그인 후 사업자 등록증을 등록해주세요.
        </v-alert>

        <v-btn
          color="success"
          class="mr-4"
          @click="singUpWithMail"
        >
          회원 가입
        </v-btn>

        <v-btn
          color="success"
          class="mr-4"
          @click="goLogin"
        >
          취소
        </v-btn>
      </v-form>
    </v-card>
    <v-bottom-sheet
      v-model="isPostCode"
      inset
    >
      <v-sheet
        class="text-center"
        height="468px"
      >
        <v-card>
          <div class="d-flex flex-no-wrap justify-space-between">
            <vue-daum-postcode @complete="setAddress($event)" />
          </div>
        </v-card>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      isPostCode: false,
      show1: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters'
      },
      User: [],
      form: {
        email: '',
        password: ''
      }
    }
  },

  created () {
  },

  destroyed () {
  },

  mounted () {
  },

  methods: {
    goLogin () {
      this.$router.replace('login')
    },

    async singUpWithMail () {
      await this.$firebase.auth().createUserWithEmailAndPassword(this.form.email, this.form.password).then(
        function () {
          console.log('회원가입 완료')
        },
        function () {
          console.log('회원가입 실패')
        }
      )
    }
  }
}
</script>
